import axios from '../../plugins/axios.js';

export default{
  async getCallLog(request) {
    return await axios.post('/api/CallLog', request);
  },  
  async getAccounts() {
    return await axios.get('/api/Accounts');
  }, 
  async getSubscriptions() {
    return await axios.get('/api/Subscription');
  }, 
  async getDIDs() {
    return await axios.get('/api/PhoneNumberRepository/GetPhoneNumberRepository?used=1');
  },
  async getAffiliateSummary(url) {
    return await axios.get('/api/AffiliateSummary?' + url);
  },
  async getAffiliateCostLog(url) {
    return await axios.get('/api/AffiliateCostLog?' + url);
  },
  async getProductTypes() {
    return await axios.get('/api/Support/GetLeadTypes');
  },
  async getAccountsAndCompanies() {
    return await axios.get('/api/Accounts/GetAccountsAndCompanies');
  },
  async downloadCallRecordingFromBlob(callSID) {
    return await axios.get(`/api/CallLog/DownloadCallRecordByCallSID/${callSID}`, { 
      responseType: 'blob' 
    })
  },
  async getInboundPingPostDetails(request) {
    return await axios.post('/api/InboundPingPost', request);
  }, 
};
